import { Payment } from '../types';
import { client } from './axiosClient';

export const postConfirmPayment = async (id: number, company_id?: string) => {
  const res = await client.post(`/client/payments/${id}/confirm`, undefined, {
    params: {
      company_id,
    },
  });
  return res.data;
};

export const getPayments90days = async (company_id?: string) => {
  const res = await client.get<Payment[]>('/client/payments', {
    params: {
      company_id,
    },
  });
  return res.data;
};
export const getYearPayments = async (company_id?: string) => {
  const res = await client.get<Payment[]>('/client/payments/year', {
    params: {
      company_id,
    },
  });
  return res.data;
};
